import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RGuestMessages } from '../../../../model/shared/backend-api-response/rguest-messages';
import { LegacyBookInitService } from '../../../../modules/shared/legacy-bookexpress/services/legacy-book-initializer.service';
@Component({
  selector: 'app-common-confirmation-dialogue',
  templateUrl: './common-confirmation-dialogue.component.html',
  styleUrls: ['./common-confirmation-dialogue.component.scss'],
})
export class CommonConfirmationDialogueComponent implements OnInit {
  rGuestBookMessages: RGuestMessages;
  constructor(
    public dialogRef: MatDialogRef<CommonConfirmationDialogueComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public config: LegacyBookInitService
  ) {
    this.rGuestBookMessages = this.config?.PropertyData?.rGuestMessages;
  }

  ngOnInit() {}
  onNo(flag = false): void {
    this.dialogRef.close(flag);
  }

  onYes(flag = true): void {
    this.dialogRef.close(flag);
  }
}
